import { NextPage } from 'next';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import Head from 'next/head';

const CreatorTerms: NextPage = () => {
  return (
    <>
      <Head>
        <title>kliggit - Creator Terms</title>
      </Head>
      <div>
        <Header />
        <div className="px-5 md:px-[4.875rem] lg:px-[8.8125rem] xl:px-[14.375rem] mb-20">
          <h1 className="mb-4 font-semibold">
            Creator Terms of Service and Use
          </h1>
          <main className="space-y-6">
            <p className="mb-6 font-semibold">Last updated: July 14, 2021</p>
            <p>
              This Creator’s Terms of Service and Use Agreement (“Terms”)
              governs your use as a Creator user of the kliggit site offered by
              kliggit Inc., doing business as kliggit (“we”, “us”, or )
              including our website (kliggit.com), mobile application (“App”),
              and services we provide (collectively, the “Site”). “You” and
              “Creator” refer to you as a Creator user of the Site.
            </p>
            <p>
              These Terms apply solely to Creator Users of our Site. Any use by
              you of our Site other than as a Creator User is governed by the
              KLIGGIT GLOBAL TERMS OF SERVICE AND USE FOR ALL USERS (“Site
              Terms”).
            </p>

            <p>
              PLEASE READ THESE TERMS CAREFULLY. By using our Site as a Creator
              User or otherwise indicating your acceptance, you represent and
              warrant you have read, understand, and agree to be bound by these
              Terms. If you do not agree, do not access or use our Site as a
              Creator.
            </p>

            <p>
              These Creator Terms are additional and not intended to replace or
              substitute for the Site Terms. These Creator Terms may expressly
              change a specific provision of the Site Terms for Creators. There
              are no implied modifications of the Site Terms.
            </p>

            <p>
              LIMITATIONS OF RIGHTS NOTICE. Sections 17 and 18 of the Global
              Terms comprise provisions governing how claims between you and
              kliggit are resolved (including limits of our liability, where
              claims may be litigated, and the time to sue), including any
              claims that arose or were asserted before the “Last Updated” date
              at the top of these Terms.
            </p>

            <ol className="ml-9 mb-[4.5rem] space-y-6 list-decimal list-inside">
              <li>
                <span className="font-bold">
                  Definitions in the Creator Terms:
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    A capitalized (or other) term not defined here has the same
                    definition given to it under the Site terms.
                  </li>

                  <li>
                    “Organization” refers to an individual, partnership or
                    corporation conducting business or any entity or other
                    organized body of people with a particular purpose.
                  </li>

                  <li>
                    “Booking Fee” refers to the price you set for each TalkTime
                    (per minute price) and any other offering you make available
                    through our Site.
                  </li>

                  <li>
                    “Net App Booking Fee” refers to the amount received by
                    kliggit after subtracting any payment to or deduction by the
                    application platform from the Booking Fee (for example, on
                    In-App Purchases made through Apple’s payment processor,
                    Apple deducts a 30% commission).
                  </li>

                  <li>
                    “Creator Content” refers to content you upload, submit,
                    store, send, transmit, approve, receive, and create,
                    including kliggit TalkTime and Videos/Recordings
                  </li>

                  <li>“You” means you as a user of our Site.</li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Registration.</span> To use our Site
                as a Creator, you must register for a kliggit account, then list
                events for other users to book:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Creator Users age 18 or older: By registering, you represent
                    and warrant that: (i) you are of legal age and capacity to
                    form a contract; (ii) you are not barred from using our Site
                    under the laws of the United States, the laws of the place
                    of your residence; (iii) and you are will comply with all
                    laws and regulations relating to your use of our Site and
                    will indemnify the kliggit Parties for any failure to do so.
                  </li>

                  <li>
                    Creator Users at least 16 years of age may register
                    directly. By registering, you represent and warrant that:
                    (i) you are at least 16 years old and, are registering with
                    the supervision and with the consent of your parent or legal
                    guardian, who also agrees to these Terms; (ii) you are of
                    legal age to form a contract; (iii) you, and your parent or
                    legal guardian is not barred from using our Site under the
                    laws of the United States, your place of residence, and the
                    place of residence of your parent or legal guardian, or any
                    other applicable jurisdiction; and (iv) you and your parent
                    or legal guardian will comply with all laws and regulations
                    relating to your use of our Site and will indemnify the
                    kliggit Parties for any failure to do so.
                  </li>

                  <li>
                    Creator Users under 16 years old, may register only through
                    a parent or legal guardian who, by registering, represents
                    and warrants that: (i) he or she is the parent or legal
                    guardian of the Creator and agrees to these Terms; (ii)
                    neither the parent or legal guardian nor the Creator is
                    barred from using our Site under the laws of the United
                    States, the place of residence of the parent, legal
                    guardian, or Creator User, or any other applicable
                    jurisdiction; and (iii) he or she will comply with all laws
                    and regulations relating to Creator’s use of our Site and
                    will indemnify the kliggit Parties for any failure to do so.
                  </li>

                  <li>
                    Organizations. By registering, the Organization represents
                    and warrants that: (i) the registrant is the authorized
                    representative of the Organization (and, if the registrant
                    is below the age of 18, is registering with any consent
                    required of the registrant’s parent or legal guardian and
                    agrees to these Terms; (ii) neither the Organization nor the
                    registrant is barred from using our Site under the laws of
                    the United States, the place of residence of the
                    Organization or any registrant or any other applicable
                    jurisdiction; and (C) Organization will comply with all laws
                    and regulations relating to Organization’s use of our Site
                    under these Terms and will indemnify the kliggit Parties for
                    any failure to do so.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Fees and Payment to Creators.</span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Booking Fee: You set your own price for each TalkTime (per
                    minute) and any other offering you make available through
                    our Site provided that: (i) the Booking Fee for each kliggit
                    Talktime must be at least $1.00 (unless it is US $0.00 for a
                    TalkTime booking of five minutes or less), or as otherwise
                    agreed in writing by us; (ii) your price on the App for iOS
                    must be an available Apple SKU; (iii) where there is no
                    identical Apple SKU, your price will be the Apple SKU
                    closest to the price you set. The Booking Fee excludes any
                    service, transaction, or processing fees paid to kliggit.
                  </li>

                  <li>
                    Fees: We will pay you 80% of the Booking Fee actually
                    received by kliggit for each kliggit TalkTime or other
                    kliggit product offering you create, except that with a
                    Booking Fee paid through the App, we will pay you 80% of the
                    Net App Booking Fee. In addition, if the offering permits a
                    User to designate an additional amount as a “tip”, we will
                    pay you 80% (unless we agree in writing to a different
                    percentage) of any amount paid by a User via our Site as a
                    &quot;tip&quot; (after subtracting any payment to or
                    deduction by the application platform).
                  </li>

                  <li>
                    Fees and Payment Representations and Warranties. You
                    represent and warrant or otherwise agree that:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) kliggit TalkTimes and Videos/Recordings are not, and
                        are not intended to be, covered by any guild, union,
                        collective bargaining, management, agency, or similar
                        agreement and there will be no residual or any other
                        payment due from kliggit to you, to any third party,
                        guild, union, management, or agent, or under any
                        collective bargaining agreement, in connection with any
                        kliggit Offering, payment from us to you, or our Site;
                      </li>

                      <li>
                        (ii) kliggit is not responsible for, and will make no
                        deduction to payments made to you for any fees,
                        commissions, costs, expenses, or payments to, or
                        regarding any third party, including any manager, agent,
                        attorney, representative, or service provider, in
                        connection with any revenue earned by or payments made
                        to you in connection with our Site; and
                      </li>

                      <li>
                        (iii) kliggit is not responsible for any contributions,
                        payments, taxes, or deductions for Social Security,
                        retirement benefits, unemployment insurance, annuities,
                        or pension or welfare fund payments required by law or
                        any labor union, or any withholding or income taxes.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Payment: You agree to
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) register with the third party payment provider
                        selected by kliggit, which we may change at our sole
                        discretion. You may not use a payment provider other
                        than the one selected by us. You will provide the
                        payment provider any information required to receive
                        payments via the payment provider, e.g., information
                        about the bank account you own at a regulated financial
                        institution. Any payments due to you from kliggit will
                        be made via the payment provider. If you do not provide
                        the payment provider with all required information, you
                        may not receive the payments due to you. kliggit will
                        not be responsible for any damages, delays, losses,
                        costs, expenses, or liabilities relating to your
                        inability to receive payments because of your failure to
                        provide such information.
                      </li>
                      <li>
                        (ii) You acknowledge and agree that kliggit does not
                        operate, own, or control the payment provider. Your use
                        of any payment provider is subject to the terms and
                        privacy policies of that payment provider. You agree
                        that we are not responsible for any delay, failure,
                        damage, or liability caused by a payment provider, any
                        other third party, a force majeure, or your failure to
                        timely or properly set up an account with the payment
                        provider or otherwise provide requested
                      </li>
                      information for payment. Other than with respect to any
                      payment to or deduction by the application platform (as
                      set forth in Section 3.b), kliggit will be responsible for
                      fees, costs, and expenses in connection with the payment
                      provider. Unless otherwise agreed, by kliggit in writing,
                      you acknowledge and agree that you are solely responsible
                      for any other fees, costs, and expenses, including
                      regarding your bank account and foreign exchange fees.
                      <li>
                        (iii) Notwithstanding anything to the contrary in these
                        Terms, if kliggit, in its sole discretion, believes that
                        any fraud, money laundering, or other violation of law
                        or regulation is taking place on or in connection with
                        our Site, you acknowledge and agree that we may
                        withhold, delay, or seek repayment of any payments we
                        believe, in our sole discretion, are related to the
                        violation.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Currency: Payments via the payment provider are in U.S.
                    dollars unless the payment provider permits you to choose
                    another currency and you do so.
                  </li>
                  <li>
                    Fundraising: If you identify any entity on your booking page
                    or elsewhere on our Site as a charitable organization or a
                    recipient of any funds you are raising (each, a “Charity”),
                    you represent and warrant:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) that you will comply with all laws and regulations
                        relating to that identification or the Charity,
                        including making disclosures, registering, or entering
                        into any agreement, such as a commercial co-venturer
                        agreement;
                      </li>

                      <li>
                        (ii) acknowledge and agree that we have the right in our
                        sole discretion to reject your identification or the
                        Charity;
                      </li>

                      <li>
                        (iii) represent and warrant that the Charity is and will
                        remain in good standing at all times the identification
                        is used, that within 48 hours of your receipt of our
                        request, you will provide us with written evidence of
                        the Charity’s good standing and charitable status in all
                        jurisdictions, and that you will promptly remove the
                        identification if the Charity ceases to be in good
                        standing;
                      </li>

                      <li>
                        (iv) represent and warrant you will make any payment to
                        the Charity (unless we expressly agree in writing in
                        advance to do so on your behalf and to satisfy our
                        payment obligations to you under these Terms); and
                      </li>

                      <li>
                        (v) represent and warrant you have all rights necessary
                        to authorize use of the Charity’s name and logo in
                        connection with (and on) our Site, in the
                        identification, and in any social and other media. You
                        further acknowledge and agree that we may add a
                        statement to your booking page disclaiming a connection
                        between kliggit and the Charity, as we determine in our
                        sole discretion.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Creator Content.</span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Your Creator Content is subject to the Intellectual Property
                    (Section 12) and all other applicable provisions of our Site
                    Terms.
                  </li>

                  <li>
                    You agree that we may display advertising with or in
                    connection with your Creator Content. You further
                    acknowledge and agree that kliggit has no obligation to you
                    in connection with any advertising displayed with our Site
                    (including no obligation to share any advertising revenue
                    received by kliggit).
                  </li>

                  <li>
                    Right to Remove Creator Content: You acknowledge and agree
                    that we cannot restrict the use of your Content, including
                    kliggit TalkTimes Videos/Recordings or other Offerings by
                    the Users for or with whom you created them or by any third
                    party with whom they have been shared and we have no
                    obligation to remove those uses (including from social media
                    channels or third party websites or platforms). If we do
                    seek to remove a kliggit Video/Recording from a social media
                    channel or third party website or platform, we may notify
                    you of our intent to do so. You will promptly notify us if
                    you learn that any Creator Content is being used in
                    violation of the Site Terms. We will reasonably cooperate
                    with your efforts to address the violation. However, you
                    acknowledge and agree that we are not responsible or liable
                    for any damages, losses, costs, expenses, or liabilities
                    related to use of the Creator Content.
                  </li>

                  <li>
                    Licenses: We may exercise our license rights under the Site
                    Terms anywhere in the universe. We may sublicense our rights
                    as needed to provide and promote our Site or otherwise under
                    these Terms, and Users may sublicense their rights subject
                    to the Site Terms. Finally, the licenses granted in the Site
                    Terms are perpetual, meaning they continue after you stop
                    using our Site.
                  </li>

                  <li>
                    Creator Content Representations and Warranties. You
                    represent and warrant that:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) you own all rights in your Creator Content (or your
                        contribution to it) and that you have the right to grant
                        the rights described in the Site Terms;
                      </li>

                      <li>
                        (ii) you have paid and will pay in full any fees,
                        royalties, or other payments due or may become due with
                        any use of your Creator Content by us, Users, or third
                        parties as described in these Terms;
                      </li>

                      <li>
                        (iii) your agreement to these Terms violates no
                        agreement you may have with any third party;
                      </li>

                      <li>
                        (iv) in connection with each Organization: (a) you are a
                        resident of the U.S.; (b)any statements you make about
                        the Organization are factually correct and not
                        misleading, are not disparaging or defamatory, and
                        represent your true opinion or knowledge; and (c) you
                        will comply with all laws, rules, and regulations,
                        including the Federal Trade Commission &quot;Guides
                        Concerning the Use of Endorsements and Testimonials in
                        Advertising,&quot; which may require adding an
                        appropriate hashtag (e.g. #ad, #sponsored) or other
                        disclosure to the Organization’s Creator Content.
                      </li>

                      <li>
                        (v) your Creator Content does not infringe,
                        misappropriate, or otherwise use without authorization,
                        any intellectual property, privacy, publicity, moral, or
                        other rights of any third party, or violate any law,
                        regulation, or court order;
                      </li>

                      <li>
                        (vi) you will not post or make publicly available any
                        kliggit TalkTime Video/Recording that the Guest has
                        requested not be posted to your page;
                      </li>

                      <li>
                        (vii) you will not contact, respond to, or communicate
                        with any User you meet on or through our Site, except as
                        permitted through our Site.
                      </li>

                      <li>
                        (viii) you will not provide your contact information to
                        any User or send merchandise or anything else to a User
                        other than as permitted by these Terms;
                      </li>

                      <li>
                        (ix) you will not edit, change, modify, or remove any
                        watermark or logo from any kliggit Video or assist or
                        encourage any third party to do so;
                      </li>
                    </ul>
                  </li>
                  <li>
                    Treatment of Creator Content.
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) Any Creator Content not classified as “private” is
                        non-confidential, non-proprietary, and must not contain
                        or include any information which you do not have the
                        right to disclose or that you do not wish to be
                        disclosed. We will not be responsible or liable for any
                        use or disclosure of Creator Content, including any
                        personal information in that Creator Content.
                      </li>

                      <li>
                        (ii) You acknowledge and agree that your relationship
                        with us is not a confidential, fiduciary, joint-venture,
                        employer/employee, agency, or other type of special
                        relationship, and that your decision to use our Site or
                        submit any Creator Content does not place us in a
                        position that is any different from the position held by
                        members of the general public, including regarding your
                        Creator Content. We will not be liable or responsible
                        for any use or disclosure of any Creator Content.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Refusal and Removal of Creator Content: We may refuse to
                    accept or transmit Creator Content without notice to you. We
                    may remove Creator Content from our Site without notice to
                    you.
                  </li>

                  <li>
                    Cancellation of Site Account: If you terminate your Site
                    account, you may, on at least three business days’ advance
                    written notice to us, request we no longer include your
                    Creator Content on our Site. We will make no new public use
                    of them. We have no obligation as to any use of your Creator
                    Content by Users for whom you created them or by any third
                    party with whom they have been shared (including from social
                    media channels or third party websites or platforms).
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">
                  Creator Relationship with kliggit.
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    You and kliggit agree you and kliggit are in a business
                    relationship. The relationship is solely an independent
                    contractor relationship. You acknowledge and agree that you
                    are not a joint venturer, franchisee, partner, agent, or
                    employee of kliggit, and will not represent yourself as
                    such. As an independent contractor using our Site to provide
                    Content or other services to Guests, you are solely and
                    exclusively responsible for determining the manner, method,
                    details, and means of your performance under these Terms.
                    You also retain the option to accept, decline, or ignore any
                    Guest request. We have no right to, and will not, control
                    the manner or determine the method of accomplishing your
                    performance. You represent and warrant you are customarily
                    engaged in an independently established trade, occupation,
                    or business.
                  </li>

                  <li>
                    You represent and warrant that (whether a Creator, parent or
                    legal guardian of a Creator, an Organization, or otherwise)
                    you assume sole responsibility and liability for and will
                    pay or cause to be paid all contributions, payments, taxes,
                    and deductions for Social Security, retirement or other
                    benefits, healthcare insurance, unemployment insurance,
                    annuities, pension and welfare fund payments required by
                    law, regulation, or any labor union, and all withholding and
                    income taxes, and make any reports required because of your
                    use of our Site under these Terms.
                  </li>

                  <li>
                    You are solely responsible for making any disclosure
                    required by any law, regulation, court order or any
                    agreement with any third parties to any person or entity
                    regarding your performance under these Terms.
                  </li>

                  <li>
                    Your relationship with kliggit is non-exclusive, including
                    your right to provide similar Content or services to
                    kliggit’s competitors, and you may engage in other business
                    or employment activities. Similarly, we can engage third
                    parties to provide Content or services similar to those that
                    you may provide under these Terms.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Other Creator Terms.</span> You
                agree that:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    We may record a public kliggit Talktime or any public Event,
                    which we may edit or modify (for example, add music or
                    captions and capture screenshots or excerpts). The Content
                    may be included in a compilation with content from or
                    featuring others.
                  </li>

                  <li>
                    Unless we notify you otherwise, including modifying the Site
                    Terms, any desired conditions, limitations, restrictions, on
                    using any kliggit TalkTime you offer must be posted on your
                    booking page.
                  </li>

                  <li>
                    A Guest may end a TalkTime at any time. If a TalkTime is
                    ended due to a violation of the Site Terms, you will
                    promptly notify kliggit in writing at{' '}
                    <a href="mailto:creator@kliggit.com">creator@kliggit.com</a>
                    .
                  </li>

                  <li>
                    If you end a TalkTime earlier than scheduled for any other
                    reason, we may discuss with you an appropriate adjustment of
                    the payment made to you. Any adjustments for early
                    terminations and cancellations are subject to the Site
                    Terms.
                  </li>

                  <li>
                    kliggit may monitor any TalkTime, and retains the right, in
                    its sole discretion, to terminate or cancel any TalkTime or
                    block any User.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Termination of Your Account.</span>{' '}
                You may cancel your Site account at any time by contacting a
                member of our team at{' '}
                <a href="mailto:creator@kliggit.com">creator@kliggit.com</a>.
              </li>
            </ol>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default CreatorTerms;
